/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_Valve_DescriptionInputs */



/**
* | output |
* | --- |
* | "Connected thermostatic heads adjust each radiator to the room's occupancy schedule, to heat just what is needed, when it is needed." |
*
* @param {Go_Further_Valve_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_valve_description = /** @type {((inputs?: Go_Further_Valve_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_Valve_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Connected thermostatic heads adjust each radiator to the room's occupancy schedule, to heat just what is needed, when it is needed.")
	return /** @type {LocalizedString} */ ("Des têtes thermostatiques connectées ajustent chaque radiateur selon le planning d'occupation de la pièce, pour chauffer juste ce qu'il faut, quand il le faut.")
});